import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { ViewItem } from '../model/view-item.model';

export interface ToggleItemExpand {
    items: ViewItem[];
}

export const toggleItemExpand = createAction<ActionType, ToggleItemExpand>(
    ActionType.NOTI__EC__TOGGLE_ITEM_EXPAND,
);
